import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import React, { useState } from 'react';
import { useAppSelector } from '@/hooks/reduxHooks';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { Product } from '@/models/Product';
import { selectCurrentVendor } from '@/store/features/locationSlice';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
import addWishlist from '@/utils/api/addWishlist';
import removeWishlist from '@/utils/api/removeWishlist';
import { getCookieValue } from '@/utils/helper';
import WishlistIcon from './icons/WishlistIcon';
import { requiredPathName } from './products/AddToCart2';
import { Toast } from './Toast';
interface WishlistProps {
  width?: number;
  height?: number;
  productInWishlist: boolean;
  product: Product;
  onWishlistChange?: (isInWishlist: boolean) => void;
}
const Wishlist = ({
  width = 40,
  height = 40,
  productInWishlist = false,
  product,
  onWishlistChange
}: WishlistProps) => {
  const {
    t
  } = useTranslation('common');
  const userId = getCookieValue('user_id');
  const router = useRouter();
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const vendorDetails = useAppSelector(selectCurrentVendor);
  const [isProductInWishlist, setIsProductInWishlist] = useState(productInWishlist || false);
  const [toastMsg, setToastMsg] = useState('');
  const [showToast, setShowToast] = useState(false);
  const handleWishlist = async () => {
    try {
      const res = await (isProductInWishlist ? removeWishlist : addWishlist)({
        userId: userId,
        productId: Number(product.id)
      });
      if (res) {
        const newState = !isProductInWishlist;
        if (newState) {
          const eventParams = {
            ProductName: `${product?.name}`,
            ProductBrand: product?.brand?.name,
            VendorName: vendorDetails?.company_name,
            VendorId: vendorDetails?.id,
            ScreenName: router.asPath,
            PageName: requiredPathName(router.asPath)
          };
          trackCustomEvent(CustomEventTypes.PRODUCT_ADDED_TO_WISHLIST, JSON.stringify(eventParams));
        }
        setIsProductInWishlist(newState);
        onWishlistChange?.(newState);
        setToastMsg(t(newState ? 'product_add_to_wishlist' : 'product_removed_from_wishlist'));
        setShowToast(true);
      } else {
        setToastMsg(t('login_to_add_wishlist'));
        setShowToast(true);
      }
    } catch (error) {
      console.error('Wishlist operation failed:', error);
    }
  };
  return <>
      <WishlistIcon width={width} height={height} isActive={isProductInWishlist} onClick={handleWishlist} data-sentry-element="WishlistIcon" data-sentry-source-file="Wishlist.tsx" />
      {showToast && <Toast message={toastMsg} onClose={() => setShowToast(false)} />}
    </>;
};
export default Wishlist;